export enum LoginType {
	Google = 'google',
	EmailWithPassword = 'emailWithPassword',
	Anonymous = 'anonymous',
	Apple = 'apple'
}

export enum GameType {
	Sudoku = 'sudoku',
	Crossword = 'crossword',
	WordSearch = 'wordsearch',
	GridPuzzle = 'gridpuzzle'
}

export enum ModalType {
	JokerShopModal = 'jokerShop',
	PromoCodeModal = 'promoCode',
	WordChestModal = 'wordChest',
	AvatarModal = 'avatar',
	HelpModal = 'help',
	DeleteModal = 'delete',
	FeedbackModal = 'feedback',
	SuggestionFeedback = 'suggestion',
	ResponseFeedback = 'response',
	GameStartModal = 'gameStart',
	LoginModal = 'login',
	ForgotPasswordModal = 'forgotPassword',
	SignUpModal = 'signup',
	GameLostModal = 'gameLost',
	GameUpdateModal = 'gameUpdate',
	GameWinModal = 'gameWin',
	ChestModal = 'chestModal',
	GamePurchaseModal = 'gamePurchase'
}

export enum TrackingType {
	AppStarted = '_APP_STARTED_',
	PurchaseStart = '_PURCHASE_START_',
	PurchaseComplete = '_PURCHASE_COMPLETE_',
	LoginRegister = '_LOGIN_REG_BY_',
	VideoAdStart = '_VIDEO_AD_START_',
	VideoAdComplete = '_VIDEO_AD_COMPLETE_',
	VideoAdError = '_VIDEO_AD_ERROR_',
	OverlayOpen = '_OVERLAY_OPEN_',
	CollectTimeBonus = '_COLLECT_TIME_BONUS',
	GameOpenLobby = '_GAME_OPEN_LOBBY_',
	GameLoad = '_GAME_LOAD_',
	GameExit = '_GAME_EXIT_',
	GameFailed = '_GAME_FAILED_',
	GameComplete = '_GAME_COMPLETE_',
	JokerGameUseField = '_JOKER_GAME_USE_FIELD_',
	JokerGameUseContinue = '_JOKER_GAME_USE_CONTINUE_',
	JokerSheetPurchase = '_JOKER_SHEET_PURCHASE_',
	PromoCodeEntered = '_PROMO_CODE_ENTERED',
	PromoCodeBooked = '_PROMO_CODE_BOOKED_',
	PlayerDataChanged = '_PLAYER_DATA_CHANGED'
}
